/* This example requires Tailwind CSS v2.0+ */
import { Disclosure, Popover, Transition } from "@headlessui/react";
import { ChevronDownIcon, MailIcon, MenuIcon, ScaleIcon, SparklesIcon, XIcon } from "@heroicons/react/outline";
import { Fragment, useEffect, useState } from "react";
import { trackLogin } from "../../helpers/mixpanel";
import { classNames } from '../../helpers/classNames'
import GetStartedButton from "../../routes/publicPages/components/GetStartedButton";

// images
const abundoLogo =
  "https://res.cloudinary.com/abundo-wealth-assets/image/upload/v1658176803/Abundo%20Wealth%20Assets/components/logos/Abundo_logo_mtnbxi_zg4tju.webp";
// end images
const aboutUsMenu = [

  {
    name: 'Our Story',
    description: 'Learn more about our company values and mission to give everyone accessible financial advice.',
    href: '/our-story',
    icon: ScaleIcon
  },

  {
    name: 'Our Team',
    description: 'Meet our amazing team of talented individuals from across the country.',
    href: '/our-story#our-team',
  },
  {
    name: "Blog",
    description: "Stay up-to-date with our posts on investing, financial planning, and travel.",
    href: "/blog",
    icon: SparklesIcon
  },
  {
    name: 'Media',
    description: 'Information for reporters and the media as well as a collection of where we have been featured.',
    href: '/media',
  },

  {
    name: 'Careers',
    description: 'Want join our mission? Learn more!',
    href: '/careers',
    icon: ScaleIcon
  },
  {
    name: "Contact Us",
    description: 'Can’t find the answer you’re looking for? Get in touch.',
    href: "/faq#contact-us",
    icon: ScaleIcon
  },
  {
    name: 'FAQ',
    description: 'Find answers to common questions about our service.',
    href: '/faq',
    icon: ScaleIcon
  },




];

const whoWeHelpMenu = [
  {
    name: 'Just Getting Started',
    description: 'Those in their 20s and 30s who need help with budgeting, debt management, and building a strong foundation.',
    href: '/who-we-help/just-getting-started',
    icon: ScaleIcon
  },
  {
    name: 'Mid-Career Professionals',
    description: 'Busy professionals who have investment decisions, family goals, and travel aspirations.',
    href: '/who-we-help/mid-career-professionals',
    icon: ScaleIcon
  },
  {
    name: 'Thinking About Retirement',
    description: 'Pre-retirees who have questions about retirement timing, managing healthcare costs, and optimizing their portfolio.',
    href: '/who-we-help/thinking-about-retirement',
    icon: ScaleIcon
  },
  {
    name: 'Looking For A New Advisor',
    description: 'Those who are considering switching advisors to lower fees and receive more holistic financial advice.',
    href: '/who-we-help/looking-for-advisor',
    icon: ScaleIcon
  },
  {
    name: 'DIYers Seeking Guidance',
    description: 'DIYers who want another set of eyes and professional insights to complement their independent spirit.',
    href: '/who-we-help/diyer-seeking-guidance',
    icon: ScaleIcon
  },
];


const navigation = [
  {
    name: "What To Expect",
    href: "/what-to-expect",
    current: window.location.href.includes("/what-to-expect"),
  },
  {
    name: "Who We Help",
    href: "/about",
    current: window.location.href.includes("/about"),
    menu: whoWeHelpMenu
  },

  {
    name: "About",
    current: window.location.href.includes("/how_we_help"),
    menu: aboutUsMenu
  },




  // {
  //     name: "Blog",
  //     current: window.location.href.includes("/faq"),
  //     menu: aboutUsMenu
  //   },
  {
    name: "Pricing",
    href: "/#pricing",
    current: window.location.href.includes("/pricing"),
  },


];



const handleLoginClick = () => {
  trackLogin()
}

const Navbar = () => {
  useEffect(() => {
    const pricing = document.getElementById("pricing");
    if (window.location.href.includes("#pricing")) {
      pricing.scrollIntoView();
    }
  }, []);
  return (
    <Disclosure as="nav" className="bg-white sticky top-0 z-50">
      {({ open }) => (
        <>
          <div className=" px-4 sm:px-6 lg:px-10 border-b">
            <div className="flex justify-between h-24 relative">
              <div className="flex">
                <div className="-ml-2 mr-2 flex items-center lg:hidden">
                  {/* Mobile menu button */}
                  <Disclosure.Button className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-white hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white">
                    <span className="sr-only">Open main menu</span>
                    {open ? (
                      <XIcon className="block h-6 w-6" aria-hidden="true" />
                    ) : (
                      <MenuIcon className="block h-6 w-6" aria-hidden="true" />
                    )}
                  </Disclosure.Button>
                </div>
                <div className="flex-shrink-0 flex items-center py-2 pr-3">
                  <a href="/" className="h-full flex">
                    {" "}
                    <img
                      className="block lg:hidden my-auto h-12 aspect-[7/4]"
                      src={abundoLogo}
                      alt="Abundo"
                    />
                  </a>
                  <a href="/" className="h-full flex ">
                    {" "}
                    <img
                      className="hidden lg:block h-16 my-auto aspect-[7/4]"
                      src={abundoLogo}
                      alt="Abundo"
                    />
                  </a>
                </div>
              </div>
              <div className="flex items-center justify-between ">
                {" "}
                <div className="hidden  lg:flex absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 space-x-5  xl:space-x-7 items-center ">
                  {navigation.map((item) => (
                    item.menu ?
                      <Popover className="relative">
                        <Popover.Button className={classNames(item.current && 'text-gray-900 border-b border-secondary-500', false ? 'block px-3 py-2 rounded-md  font-medium text-gray-700 hover:text-gray-900 hover:bg-gray-50' :
                          "font-medium text-gray-700 hover:text-gray-900", "inline-flex items-center text-base xl:text-xl gap-x-1 px-1")}
                        >
                          <span className=''>{item.name}</span>
                          <ChevronDownIcon className="h-4 w-4 mt-1" aria-hidden="true" />
                        </Popover.Button>

                        <Transition
                          as={Fragment}
                          enter="transition ease-out duration-200"
                          enterFrom="opacity-0 translate-y-1"
                          enterTo="opacity-100 translate-y-0"
                          leave="transition ease-in duration-150"
                          leaveFrom="opacity-100 translate-y-0"
                          leaveTo="opacity-0 translate-y-1"
                        >
                          <Popover.Panel className="absolute left-1/2 z-10 mt-5 flex w-screen max-w-max -translate-x-1/2 px-4">
                            <div className="w-screen max-w-md flex-auto overflow-hidden rounded-xl bg-white text-sm leading-6 shadow-xl ring-1 ring-gray-900/5">
                              <div className="p-4">
                                {item.menu.map((item) => (
                                  <a href={item.href} key={item.name} className="group relative flex gap-x-6 rounded-lg p-2.5 hover:bg-gray-100">

                                    <div>
                                      <p className="font-semibold text-base text-gray-900">
                                        {item.name}
                                      </p>
                                      <p className=" text-gray-600 text-sm leading-5">{item.description}</p>
                                    </div>
                                  </a>
                                ))}
                              </div>
                              <div className="grid  grid-cols-2 divide-x divide-gray-900/5 bg-gray-100">

                                <div
                                  className="flex items-center justify-center gap-x-2.5 p-3 font-semibold text-gray-900 hover:bg-gray-100"
                                >
                                  <SparklesIcon className="h-5 w-5 flex-none text-gray-400" aria-hidden="true" />
                                  <GetStartedButton id='navbar-dropdown' className="" />
                                </div>


                                <a
                                  href='/faq#contact-us'

                                  className="flex items-center justify-center gap-x-2.5 p-3 font-semibold text-gray-900 hover:bg-gray-100"
                                >
                                  <MailIcon className="h-5 w-5 flex-none text-gray-400" aria-hidden="true" />
                                  Contact Us
                                </a>
                              </div>
                            </div>
                          </Popover.Panel>
                        </Transition>
                      </Popover> :
                      <a href={item.href} className={classNames(item.current && 'text-gray-900',
                        "font-medium text-gray-700 text-left hover:text-gray-900", "text-base xl:text-xl inline-flex items-center gap-x-1 px-1")}>
                        {item.name}
                      </a>
                  ))}
                </div>
                <div className="hidden xl:flex flex-shrink-0 space-x-4 items-center">
                  <GetStartedButton id='navbar' className="btn-3xl btn-secondary" />
                  <a
                    href="/login"
                    onClick={() => { handleLoginClick() }}
                    className="btn-3xl  btn-secondary-outline "
                  >
                    <span>Login</span>
                  </a>
                </div>
                <div className=" xl:hidden flex-shrink-0 space-x-4 items-center">
                  <GetStartedButton id='navbar' className="btn-lg sm:btn-2xl btn-secondary" />
                  <a
                    href="/login"
                    onClick={() => { handleLoginClick() }}
                    className="btn-lg sm:btn-2xl  btn-secondary-outline "
                  >
                    <span>Login</span>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <Disclosure.Panel className="lg:hidden shadow-lg">
            <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
              {navigation.map((item) => (
                <MobileNavItem item={item} />
              ))}
            </div>
          </Disclosure.Panel>
        </>
      )}
    </Disclosure>
  );
};
export default Navbar;


function MobileNavItem({ item }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      {

        item.menu ?
          <div>
            <button onClick={() => setOpen(!open)}
              className={classNames(
                item.current
                  ? "text-gray-800"
                  : "text-gray-800 hover:bg-gray-700  hover:text-white",
                " px-3 py-2 rounded-md text-base font-medium flex space-x-1 items-center w-full"
              )}
              aria-current={item.current ? "page" : undefined}
            >
              <p> {item.name}</p> <ChevronDownIcon className={classNames("h-5 w-5 transform transition duration-100", open && "rotate-180")} />
            </button>
            {open &&
              <ul className=" ml-5">
                {item.menu.map((menuItem) => (
                  <a
                    className={classNames(
                      "text-gray-800 hover:bg-gray-600  hover:text-white",
                      " px-3 py-2 rounded-md text-base font-medium flex space-x-1 items-center w-full"
                    )}
                    href={menuItem.href}>
                    {menuItem.name}
                  </a>
                ))}

              </ul>
            }
          </div>
          : <Disclosure.Button
            key={item.name}
            as="a"
            href={item.href}
            className={classNames(
              item.current
                ? "text-gray-800"
                : "text-gray-800 hover:bg-gray-700 hover:text-white",
              "block px-3 py-2 rounded-md text-base font-medium"
            )}
            aria-current={item.current ? "page" : undefined}
          >
            {item.name}
          </Disclosure.Button>
      }
    </>
  )
}